import { getSafeHttpUrl } from 'shared/lib/security/safeUrl'

const HTTP_SCHEME_PATTERN = /^https?:\/\//i

export const getUrl = (url: string | null | undefined) => {
  const value = (url ?? '').trim()
  if (!value) {
    return undefined
  }

  return getSafeHttpUrl(HTTP_SCHEME_PATTERN.test(value) ? value : `http://${value}`)
}
